export default __webpack_public_path__ + "static/media/clockinInfo.c7d62155.png";